// extracted by mini-css-extract-plugin
export default {"screenXLMin":"1279px","step-number-container":"styles_step-number-container__vLFL6","step-number":"styles_step-number__S83K6","step-number__name":"styles_step-number__name__z2G1P"};